export const SERVER_URL = 'https://api.ifancy.com.tw' // AWS Production SSL
// export const SERVER_URL = 'http://api.ade-tech.cn:2303' // Alicloud Production
// export const SERVER_URL = 'http://127.0.0.1:2302' // for personal test

export const WS_DATA_URL = { 'ip': 'ws.ifancy.com.tw', 'port': 8083 }
export const WSS_DATA_URL = { 'ip': 'ws.ifancy.com.tw', 'port': 8084 }
export const WSS_SNAPSHOT_URL = { 'ip': 'ws.ifancy.com.tw', 'port': 8084 }
export const WS_SNAPSHOT_URL = { 'ip': 'snapshot.ifancy.com.tw', 'port': 8083 }
export const WS_SINGAL_URL = { 'ip': '127.0.0.1', 'port': 9000 }

// export const SERVER_URL = 'http://172.24.150.12:2304'
// export const WS_URL = { 'ip': '172.24.150.12', 'port': 8083 }
// export const WS_DATA_URL = { 'ip': '172.24.150.12', 'port': 8083 }
// export const WS_SNAPSHOT_URL = { 'ip': '172.24.150.12', 'port': 8083 }

// HCH 10.125.6.41 BHCH-hexagram broker 10.125.8.41 BHCH-iothexagram
// export const SERVER_URL = 'http://10.125.6.41:8080'
// export const WS_URL = { 'ip': '10.125.8.41', 'port': 8083 }
// export const WS_DATA_URL = { 'ip': '10.125.8.41', 'port': 8083 }
// export const WS_SNAPSHOT_URL = { 'ip': '10.125.8.41', 'port': 8083 }

// export const SERVER_URL = 'http://192.168.50.137:2303' // for local cloud
// export const WS_URL = { 'ip': '192.168.50.137', 'port': 8083 }
// export const WS_DATA_URL = { 'ip': '192.168.50.137', 'port': 8083 }
// export const WS_SNAPSHOT_URL = { 'ip': '192.168.50.137', 'port': 8083 }
export const GOOGLE_TRACKING_ID = 'UA-109179549-1'

export const DEFAULT_PAGE_LIMIT = 20



// WEBPACK FOOTER //
// ./src/config.js